// extracted by mini-css-extract-plugin
module.exports = {"container":"_1McY-","innerContainer":"_2RZOB","voteIcon":"_8QN_a","voteIconInactive":"_22Os6","voteCount":"_1QJCX"};